import React from 'react';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import { Section, ImageSection, TextSection } from '../../styles/Section';
import { StyledTypography } from '../../styles/Typography';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

function SectionTransfer() {
  return (
    <Section id="beneficios">
      <ImageSection>
        <FormattedMessage id="FGTS.TRANSFER.ALT_IMAGE">
          {([alt]) => (
            <ResponsiveImages
              fileName="mockup-transfer-fgts/mockup-transfer-fgts.jpg"
              alt={alt}
              width="375px"
              loading="lazy"
            />
          )}
        </FormattedMessage>
      </ImageSection>
      <TextSection>
        <StyledTypography
          variant="title"
          intlKey="FGTS.TRANSFER.TITLE"
        />
        <StyledTypography
          variant="subtitle"
          intlKey="FGTS.TRANSFER.SUBTITLE"
        />
      </TextSection>
    </Section>
  );
}

export default React.memo(SectionTransfer);
